'use strict';
import * as $j_java$002elang$002e$002dJ$002dS$002dConsole$002dBased$002dPrint$002dStream from "./java.lang.-J-S-Console-Based-Print-Stream.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_jl_System$Streams$() {
  this.II = null;
  this.Rd = null;
  $n_jl_System$Streams$ = this;
  this.II = new $j_java$002elang$002e$002dJ$002dS$002dConsole$002dBased$002dPrint$002dStream.$c_jl_JSConsoleBasedPrintStream(false);
  this.Rd = new $j_java$002elang$002e$002dJ$002dS$002dConsole$002dBased$002dPrint$002dStream.$c_jl_JSConsoleBasedPrintStream(true);
}
export { $c_jl_System$Streams$ as $c_jl_System$Streams$ };
$p = $c_jl_System$Streams$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_jl_System$Streams$;
/** @constructor */
function $h_jl_System$Streams$() {
}
export { $h_jl_System$Streams$ as $h_jl_System$Streams$ };
$h_jl_System$Streams$.prototype = $p;
var $d_jl_System$Streams$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_jl_System$Streams$, "java.lang.System$Streams$", ({
  ko: 1
}));
export { $d_jl_System$Streams$ as $d_jl_System$Streams$ };
var $n_jl_System$Streams$;
function $m_jl_System$Streams$() {
  if ((!$n_jl_System$Streams$)) {
    $n_jl_System$Streams$ = new $c_jl_System$Streams$();
  }
  return $n_jl_System$Streams$;
}
export { $m_jl_System$Streams$ as $m_jl_System$Streams$ };
